import React from 'react';
import Dialog from '../../../../core/layout/Dialog';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Button from '../../../../core/form/Button';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import Select from '../../../../core/form/Select';
import get from 'lodash/get';
import range from 'lodash/range';
import FetchSelect from '../../../../core/form/FetchSelect';
import Separator from '../../../../core/layout/Separator';

const UnitDivisionFormDialog = (props) => (
  <Dialog
    title="Unit division"
    isOpen={props.isOpen}
    width={800}
    onCancel={props.onCancel}
    actions={[
      <Button
        icon="reload"
        label="Cancel"
        key="cancel"
        onClick={props.onCancel}
        loading={props.submitting}
        disabled={props.submitting}
      />,
      <Button
        icon="check"
        label="Divide"
        key="divide"
        onClick={props.onDivide}
        loading={props.submitting}
        disabled={props.submitting}
      />,
    ]}
  >
    <Row>
      <Column size={6}>
        <TextInput
          label="Unit name"
          value={get(props.values, 'name', '')}
          onChange={(value) => props.onChange('name', value)}
          required
          errorText={get(props.errors, 'name', '')}
        />
      </Column>
      <Column size={3}>
        <FetchSelect
          required
          showSearch
          url="modules"
          params={{
            verbose: false,
            query: {
              course: get(props.values, 'course', ''),
            },
          }}
          disabled
          label="Module"
          value={get(props.values, 'module', '')}
          onChange={() => false}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={3}>
        <FetchSelect
          required
          showSearch
          url={'/unit-types'}
          disabled
          label="Unit Type"
          value={get(props.values, 'type', '')}
          onChange={(type) => props.onChange('type', type)}
          errorText={get(props.errors, 'type', '')}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
    </Row>
    <Row>
      <Column size={3}>
        <Select
          required
          options={['A', 'B', 'C', 'D'].map((value) => ({
            value,
            label: value,
          }))}
          label="Group"
          value={get(props.values, 'group', '')}
          onChange={(value) => props.onChange('group', value)}
          errorText={get(props.errors, 'group', '')}
        />
      </Column>
      <Column size={3}>
        <Select
          required
          options={range(1, 41).map((value) => ({
            value,
            label: value.toString(),
          }))}
          label="Order"
          value={get(props.values, 'order', '')}
          onChange={(value) => props.onChange('order', value)}
          errorText={get(props.errors, 'order', '')}
        />
      </Column>
      <Column size={3}>
        <Select
          required
          options={range(70, 105, 5).map((value) => ({
            value,
            label: value.toString(),
          }))}
          disabled
          label="Score to pass"
          value={get(props.values, 'scoreToPass', '')}
          onChange={() => false}
        />
      </Column>
      <Column size={3}>
        <Select
          required
          options={[
            { label: 'EASY', value: 'EASY' },
            { label: 'MODERATE', value: 'MODERATE' },
            { label: 'HARD', value: 'HARD' },
          ]}
          disabled
          label="Difficulty"
          value={get(props.values, 'difficulty', '')}
          onChange={() => false}
        />
      </Column>
    </Row>
    <Separator />
    <Row>
      <Column size={12}>
        <span>
          The points of the source unit will be divided by 2 and a half of these points will go to the new unit. As the
          points are multiple of 5, if the result of the division is not an integer, the bigger part of the points will
          stay in the source unit.
        </span>
      </Column>
    </Row>
  </Dialog>
);

UnitDivisionFormDialog.propTypes = {
  isOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDivide: PropTypes.func.isRequired,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
};

UnitDivisionFormDialog.defaultProps = {
  isOpen: false,
  values: {},
  errors: {},
  submitting: false,
};

export default UnitDivisionFormDialog;
